export const hrefNavigationOne = 
`{
    "meta": {
        "asOf": "2024-10-30T17:38:09.795Z",
        "lastUpdated": "2024-10-28T07:12:30.153Z",
        "node": "us-east-1",
        "release": "xp3.14.0.139",
        "totalHits": 2
    },
    "data": [
        {
            "href": "snapshot/MjAyNC0xMC0yOFQxMjoyMTowMi44NTZa",
            "description": "FI Reference Data snapshot at datetime 2024-10-28T12:21:02.856Z",
            "lastUpdated": "2024-10-28T07:12:30.153Z"
        },

        {
            "href": "snapshot/MjAyNC0xMC0yOFQxMjoyMTowMi44aRTa",
            "description": "FI Reference Data snapshot at datetime 2024-10-21T12:20:01.234Z",
            "lastUpdated": "2024-10-21T12:20:01.234Z"
        }
    ]
}`;

export const hrefNavigationTwo =
`{
    "meta": {
        "asOf": "2024-10-30T18:02:54.057Z",
        "lastUpdated": "2024-10-28T07:12:30.153Z",
        "node": "us-east-1",
        "release": "xp3.14.0.139",
        "totalHits": 3
    },
    "data": [
        {
            "href": "snapshot/MjAyNC0xMC0yOFQxMjoyMTowMi44NTZa/CG",
            "description": "FI Reference Data snapshot at datetime 2024-10-28T12:21:02.856Z for Corporate And Government Bonds",
            "lastUpdated": "2024-10-28T07:12:30.153Z"
        },
        {
            "href": "snapshot/MjAyNC0xMC0yOFQxMjoyMTowMi44NTZa/SF",
            "description": "FI Reference Data snapshot at datetime 2024-10-28T12:21:02.856Z for Structured Finance",
            "lastUpdated": "2024-10-28T07:12:08.638Z"
        },
        {
            "href": "snapshot/MjAyNC0xMC0yOFQxMjoyMTowMi44NTZa/USMunis",
            "description": "FI Reference Data snapshot at datetime 2024-10-28T12:21:02.856Z for US Municipals",
            "lastUpdated": "2024-10-28T07:12:05.648Z"
        }
    ]
}`;

export const hrefNavigationThree =
`{
    "meta": {
        "asOf": "2024-10-30T18:13:31.904Z",
        "lastUpdated": "2024-10-28T07:12:30.153Z",
        "node": "us-east-1",
        "release": "xp3.14.0.139",
        "totalHits": 50000
    },
    "data": [
        {
            "couponTypeSIXExpanded": "Fixed",
            "debtInstrumentType": "Bond",
            "isin": "XS2754424880",
            "issuanceCouponRate": 4,
            "issueCurrency": "EUR",
            "jurisdictionSIXExpanded": "Turkey",
            "maturityDate": "2025-01-28",
            "offeringType": "ISIN",
            "productReference": "CG",
            "issuer": {
                "country": "TR",
                "region": "Middle East",
                "name": "DenizBank A.S.",
                "sectorSIXExpanded": "Banks"
            },
            "puttable": false,
            "callable": false,
            "lastUpdated": "2024-08-19T22:33:02.327Z",
            "isActive": true
        }

    ]
}`;

export const hrefNavigationFour =
`{
    "meta": {
        "asOf": "2024-10-30T18:13:31.904Z",
        "lastUpdated": "2024-10-28T07:12:30.153Z",
        "node": "us-east-1",
        "release": "xp3.14.0.139",
        "totalHits": 50000
    },
    "data": [
        {
            "couponTypeSIXExpanded": "Fixed",
            "debtInstrumentType": "Bond",
            "isin": "XS2754424880",
            "issuanceCouponRate": 4,
            "issueCurrency": "EUR",
            "jurisdictionSIXExpanded": "Turkey",
            "maturityDate": "2025-01-28",
            "offeringType": "ISIN",
            "productReference": "CG",
            "issuer": {
                "country": "TR",
                "region": "Middle East",
                "name": "DenizBank A.S.",
                "sectorSIXExpanded": "Banks"
            },
            "puttable": false,
            "callable": false,
            "lastUpdated": "2024-08-19T22:33:02.327Z",
            "isActive": true
        }
    ]
}`;

export const hrefNavigationFive =
`{
    "meta": {
        "asOf": "2024-10-30T07:12:30.153Z",
        "lastUpdated": "2024-10-28T07:13:04.538Z",
        "node": "us-east-1",
        "release": "xp3.14.0.139",
        "totalHits": 10
    },
    "data": [
        {
            "href": "update/CG/NorthAmerica/CG~NorthAmerica~2024-10-28T08:13:04.538Z~28e9b339d6513563067a0c7fa45ab22e",
            "description": "FI Reference Data updates for Corporate And Government Bonds data type and NorthAmerica SIX region, last updated at 2024-10-28T08:13:04.538Z",
            "lastUpdated": "2024-10-28T08:13:04.538Z"
        },
        {
            "href": "update/CG/APAC/CG~APAC~2024-10-28T07:13:04.538Z~6255f8a26ca31a488e8733aef257c1c0",
            "description": "FI Reference Data updates for Corporate And Government Bonds data type and APAC SIX region, last updated at 2024-10-30T07_13_04.538Z",
            "lastUpdated": "2024-10-30T07:13:04.538Z"
        },
        ...
    ]
}`;

export const exampleOne =
`https://api.six-group.com/bulk/v1/referenceData/baseFixedIncome/snapshot/MjAyNC0xMC0yOFQxMjoyMTowMi44NTZa/CG
https://api.six-group.com/bulk/v1/referenceData/baseFixedIncome/snapshot/MjAyNC0xMC0yOFQxMjoyMTowMi44NTZa/SF
https://api.six-group.com/bulk/v1/referenceData/baseFixedIncome/snapshot/MjAyNC0xMC0yOFQxMjoyMTowMi44NTZa/USMunis`;

export const exampleTwo =
`referenceData/baseFixedIncome/update/?updatedSince=2024-10-28T07:12:30.153Z&asOf=2024-10-28T19:12:30.153Z
referenceData/baseFixedIncome/update/?updatedSince=2024-10-28T19:12:30.153Z&asOf=2024-10-29T07:12:30.153Z
referenceData/baseFixedIncome/update/?updatedSince=2024-10-29T07:12:30.153Z&asOf=2024-10-29T19:12:30.153Z
referenceData/baseFixedIncome/update/?updatedSince=2024-10-29T19:12:30.153Z`;

export const postmanOne = `https://api.six-group.com/bulk/v1/referenceData/extendedFixedIncome/snapshot`;

export const pythonOne =
`import urllib.request
import ssl
import time
import json
import io
import gzip
import concurrent.futures
from typing import List, Dict, Any
from datetime import datetime
 
class APIError(Exception):
    def __init__(self, message: str, correlation_id: str = None):
        self.message = message
        self.correlation_id = correlation_id
        super().__init__(message)
  
"""
Class wraps up calls to Bulk API.
"""    
class BulkAPIHelper:
    def __init__(self, rooturl: str):
        self.url = rooturl
        self.maxthreads = 40
        self._snapshotID = ""
        self._snapshotDateTime = ""
        self.urlSnapshotTree: List[str] = []
        self.urlUpdateTree: List[str] = []
        self.headers = {
            "accept": "application/json",
            "Accept-Encoding": "gzip, deflate"
        }
        self.context = ssl.create_default_context()
        ## Action: Change the folder to where you store your signed certificate and private key
        certificate_path = r"C:\\Certificates"
        ## Optional Action: Change to your certificate and private key names.
        self.context.load_cert_chain(f'{certificate_path}/signed-certificate.pem', f'{certificate_path}/private-key.pem')
  
    """
    Make an HTTP request and send the raw response.
    """
    def __http_request(self, append: str = '') -> Dict[str, Any]:
        complete_url = f"{self.url}/{append}" if append else self.url
        try:     
            request = urllib.request.Request(complete_url, headers=self.headers)
            with urllib.request.urlopen(request, context=self.context) as response:
                if response.info().get('Content-Encoding') == 'gzip':
                    buf = io.BytesIO(response.read())
                    with gzip.GzipFile(fileobj=buf) as f:
                        decompressed_data = f.read()
                else:
                    decompressed_data = response.read()
                return json.loads(decompressed_data)
        except urllib.error.HTTPError as err:
            correlation_id = err.headers.get('X-CorrelationID')
            print(err)
            raise APIError("An error occurred during the Bulk API request.", correlation_id) from err
              
    """
    Get information about the most recently created snapshot
    """
    def __GetLatestSnapshotID(self) -> str:
        return self.__GetLatestSnapshot()['href']
      
    def __GetLatestSnapshot(self):
        response = self.__http_request('snapshot')
        if 'data' in response:
            latest_snapshot = max(response['data'], key=lambda x: x['lastUpdated'])
            return latest_snapshot
        else:
            raise APIError("No snapshot found in the API response.")
 
    def __GetLatestSnapshotDateTime(self) -> str:
        return self.__GetLatestSnapshot()['lastUpdated']
    """
    Initialize by constructing a list of urls to query in order to download a snaphsot's full content.
    Caution: This function relies on a fixed number of 2 navigation hoops. This may not always be valid.
    """
    def InitSnapshot(self, snapshot: str = ''):
        if snapshot == '':
            self._snapshotID  = self.__GetLatestSnapshotID()
        else:
            self._snapshotID = snapshot
        assets = self.__http_request(self._snapshotID)
        for asset in assets['data']:
                if 'href' in asset:
                    buckets = self.__http_request(asset['href'])
                    for bucket in buckets['data']:
                        if 'href' in bucket:
                            self.urlSnapshotTree.append(bucket['href'])
                              
    """
    Display number of records in snapshot
    """
    def CountRecordsInSnapshot(self) -> int:
        count = 0
        with concurrent.futures.ThreadPoolExecutor(max_workers=self.maxthreads) as executor:
            futures = [executor.submit(self.__http_request, url) for url in self.urlSnapshotTree]
            for future, url in zip(futures, self.urlSnapshotTree):
                data = future.result()
                if data:
                    count = count + data['meta']['totalHits']              
        return count
     
    """
    Initialize Update by constructing a list of urls to query in order to download all updates since a given snaphsot's full content.
    """
    def InitUpdates(self):
        self._snapshotDateTime  = self.__GetLatestSnapshotDateTime()
        response = self.__http_request(f'update?from={self._snapshotDateTime}')
        for asset in response['data']:
            if 'href' in asset:
                self.urlUpdateTree.append(asset['href'])
   
    """
    Display number of records in update
    """
    def CountRecordsInUpdates(self) -> int:
        count = 0
        with concurrent.futures.ThreadPoolExecutor(max_workers=self.maxthreads) as executor:
            futures = [executor.submit(self.__http_request, url) for url in self.urlUpdateTree]
            for future, url in zip(futures, self.urlSnapshotTree):
                data = future.result()
                if data:
                    count = count + data['meta']['totalHits']             
        return count`;

export const pythonTwo =
`bulk = BulkAPIHelper('https://api.six-group.com/bulk/v1/referenceData/extendedFixedIncome')
bulk.InitSnapshot()
print("Number of records in Snapshot is: ", bulk.CountRecordsInSnapshot())
 
bulk.InitUpdates()
print("Number of records in updates since the latest Snapshot is: ", bulk.CountRecordsInUpdates())
 
del bulk`;
